// extracted by mini-css-extract-plugin
module.exports = {"title":"_1fitC-9h0vBUrEqjWmivM6"};